import moment from "moment";
import { useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Button, Col, Container, Form, Input, Row, Spinner } from "reactstrap";
import { ArticleImg } from "../assets";
import { getBlogs, subscribeBlog } from "../redux/actions/blogs.action";
const Blog = (props) => {
  const [email, setEmail] = useState("");
  const { blogs, loading } = useSelector((state) => state.blogs);
  const dispatch = useDispatch();
  useEffect(() => {
    if (blogs.length == 0) {
      dispatch(getBlogs());
    }
  }, []);

  return (
    <>
      <div id="blog" className="mt-5">
        <Container>
          <div
            style={{ width: "100%", maxWidth: "380px" }}
            className="text-center mx-auto"
          >
            <h1
              className="text-uppercase section-title "
              style={{
                fontFamily: "Ogg",
                letterSpacing: 6,
                wordSpacing: 8,
              }}
            >
              Our Blog
            </h1>
            <p>
              Tips, stories and tons of amazing content.
              <br />
              Get them weekly in your inbox
            </p>
          </div>
        </Container>
      </div>
      <div className="mx-auto ">
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            dispatch(subscribeBlog(email));
            setEmail("");
          }}
        >
          <div
            className="d-block px-3 d-md-flex  align-items-end mx-auto my-4"
            style={{ maxWidth: 720 }}
          >
            <Input
              type="email"
              className="mr-4 mb-2 mb-md-0"
              placeholder="Email *"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              style={{
                border: 0,
                borderBottom: "1px solid #000000",
                borderRadius: 0,
              }}
            ></Input>
            <Button
              className="d-block w-100 w-md-auto d-md-inline-block btn-outline text-uppercase landing-btn"
              style={{ fontSize: 14 }}
              type="submit"
              disabled={loading}
            >
              {loading ? <Spinner size="md" /> : "Subscribe"}
            </Button>
          </div>
        </Form>
      </div>
      <div
        id="articles-you-may-be-interested-in"
        className="mt-5 pt-5 section-start"
      >
        <Container className="text-center">
          <Row className="mt-4">
            {blogs.length > 0 &&
              blogs.map((blog, idx) => (
                <Col md="6" lg="4" className="text-left mb-5">
                  <Link to={`/main/blog/${blog.id}`}>
                    <div
                      // style={{
                      // 	height: '200px',
                      // 	objectFit: 'contain',
                      // }}
                      onClick={() => {
                        window.scrollTo(0, 0);
                      }}
                    >
                      <img
                        src={
                          blog.cover_images.length > 0 && blog.cover_images[0]
                        }
                        className="w-100 mb-4"
                        style={{
                          height: "200px",
                          objectFit: "contain",
                        }}
                      />
                    </div>

                    <small className="text-muted">
                      {moment
                        .unix(blog.created_at.seconds)
                        .format("DD MMMM YYYY")}
                    </small>
                    <h5
                      className="text-uppercase"
                      style={{
                        fontFamily: "Ogg",
                        letterSpacing: 6,
                      }}
                    >
                      {blog.title}
                    </h5>
                    <p className="mt-4">
                      <div
                        dangerouslySetInnerHTML={{
                          __html:
                            blog.desc.length > 100
                              ? blog.desc.substr(0, 100) + "......"
                              : blog.desc,
                        }}
                      ></div>
                    </p>
                  </Link>
                </Col>
              ))}
          </Row>
          <hr />
          <div className="d-flex justify-content-center">
            <span className="text-muted">
              <i className="fa fa-refresh mr-2"></i>
              Load More
            </span>
          </div>
        </Container>
      </div>
    </>
  );
};

export default Blog;
